module.exports = __webpack_public_path__ + "img/165.general_cleaning.dc16d4c4.svg";